module.exports = __webpack_public_path__ + "img/calculator-style-1.49d82965.png";